import React from 'react'
import { generalFilter } from '../../../../util/filter';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import { formatDate } from '../../../common/formatDate';
import { useDefaultColumn } from '../../../../util/filter';
import { useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table';
import ScreenWidth from '../../../common/ScreenWidth';
import MuiTable from "@material-ui/core/Table";
import { renderHeader } from '../../../common/util';
import { ImageDownloader } from '../../../common/ImageDownloader';
import Zoom from "react-medium-image-zoom";
import { useImage } from '../../../dataEgress/dataEgressQueries';


const ImageThumbnail = ({ file, onClick }: any) => {
    const { data, isLoading } = useImage({ file: file.download_url });
    const [error, setError] = React.useState(false);

    return (
        <div
            style={{
                width: 120,
                height: 120,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #ccc",
                position: "relative",
                textAlign: "center",
                padding: 5
            }}
        >
            {/* Loader */}
            {isLoading && (
                <LinearProgress
                    style={{
                        position: "absolute",
                        width: "100%",
                        top: "50%"
                    }}
                />
            )}

            {/* Image */}
            {!error && data && (
                <img
                    src={data}
                    alt={file.filename}
                    style={{
                        width: 120,
                        height: 120,
                        objectFit: "cover",
                        cursor: "pointer"
                    }}
                    onClick={onClick}
                    onError={() => setError(true)}
                />
            )}

            {/* Error case */}
            {!isLoading && (!data || error) && (
                <Typography
                    variant="caption"
                    style={{
                        color: "red",
                        fontSize: 11
                    }}
                >
                    Unable to view image
                </Typography>
            )}
        </div>
    );
};

export const FeedBackTableview = ({ FeedBackData }: any) => {

    const defaultColumn = useDefaultColumn();
    const widthCurrent = ScreenWidth();

    const [open, setOpen] = React.useState(false);
    const [selectedFiles, setSelectedFiles] = React.useState<any[]>([]);
    const [currentImageIndex, setCurrentImageIndex] = React.useState<number>(0);
    const [currentImage, setCurrentImage] = React.useState<any>(null);
    const [previewOpen, setPreviewOpen] = React.useState(false);




    const isImageFile = (filename: string) => {
        return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
    };
    const {
        data: rawImage,
        isLoading: isLoadingRawImage,
        isSuccess: isSuccessRawImage
    } = useImage(currentImage);


    const columns: any[] = React.useMemo(
        () => [

            {
                Header: "ID",
                id: 'id',
                accessor: "id",
                filter: generalFilter,
            },
            {
                id: "old_data",
                accessor: 'old_correction_value'
            },

            {
                id: "User Name",
                accessor: "username",
                filter: generalFilter,
                minWidth: 200,
                width: 300,
                maxWidth: 400,
                Cell: ({ cell }: any) => (
                    <Typography>
                        {cell.value ? cell.value : "N/A"}
                    </Typography>
                ),

            },
            {
                id: "FeedBack Type",
                accessor: "fb_type",
                filter: generalFilter,
                minWidth: 200,
                width: 300,
                maxWidth: 400,
                Cell: ({ cell }: any) => (
                    <Typography>
                        {cell.value ? cell.value : "N/A"}
                    </Typography>
                ),
            },
            {
                id: "Comments",
                accessor: "comments",
                minWidth: 200,
                width: 300,
                maxWidth: 400,
                filter: generalFilter,
                Cell: ({ cell, row }: any) => {
                    return (<Typography>
                        {cell.value ? cell.value : "N/A"}
                    </Typography>)
                }
            },
            {
                id: "Priority",
                accessor: "priority",
                filter: generalFilter,
                minWidth: 200,
                width: 300,
                maxWidth: 400,
                Cell: ({ cell }: any) => (
                    <Typography>
                        {cell.value ? cell.value : "N/A"}
                    </Typography>
                ),
            },
            {
                id: "Created At",
                accessor: "created_at",
                minWidth: 200,
                width: 300,
                maxWidth: 400,
                filter: generalFilter,
                Cell: ({ cell, row }: any) => {
                    return cell.value ? formatDate(cell.value) : "N/A";
                }
            },
            {
                id: "Files",
                accessor: "files",
                minWidth: 150,
                width: 200,
                Cell: ({ cell }: any) => {
                    const files = cell.value;

                    if (!files || files.length === 0) {
                        return <Typography>N/A</Typography>;
                    }

                    return (
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => {
                                setSelectedFiles(files);
                                setCurrentImageIndex(0);
                                setCurrentImage(null);   // clear preview
                                setPreviewOpen(false);   // ensure preview closed
                                setOpen(true);           // open thumbnail dialog
                            }}
                        >
                            View Files ({files.length})
                        </Button>
                    );
                }
            }

        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        rows,


    } = useTable(
        {
            data: FeedBackData || [],
            columns,
            defaultColumn,
            initialState: {
                hiddenColumns: ["id", "url", "old_data"],
            },
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination
    );
    return (
        <>

            {FeedBackData && (
                <TableContainer
                    data-testid="tableContainer"
                    // style={theme.tableContainer}
                    style={{
                        marginTop: 20, maxHeight: "500px",
                        overflowX: 'auto',
                        overflowY: 'auto',
                        whiteSpace: 'nowrap',
                        maxWidth: `${widthCurrent}px`
                    }}

                    component={Paper}
                >
                    <MuiTable stickyHeader {...getTableProps()} size="small">
                        <TableHead>
                            {headerGroups.map((headerGroup) => (
                                <TableRow {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <TableCell style={{
                                            whiteSpace: 'nowrap', width: column.width,
                                            minWidth: column.minWidth,
                                            maxWidth: column.maxWidth,
                                            textAlign: 'center',

                                        }}>
                                            <Grid
                                                container
                                                direction="row"
                                                alignItems="center"
                                                wrap="nowrap"
                                                spacing={0}
                                            >
                                                <Grid item {...column.getHeaderProps()}>
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        alignItems="center"
                                                        spacing={0}
                                                        wrap="nowrap"
                                                    >
                                                        <Typography variant="subtitle1" noWrap>
                                                            {renderHeader(column)}
                                                        </Typography>
                                                        {column.canFilter ? column.render("Filter") : null}
                                                        <Grid item wrap="nowrap">

                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableHead>
                        <TableBody {...getTableBodyProps()}>
                            {rows.map((row) => {
                                prepareRow(row);
                                return (
                                    <TableRow {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                            return (
                                                <TableCell {...cell.getCellProps()} style={{ whiteSpace: 'nowrap' }}>
                                                    {cell.render("Cell")}

                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </MuiTable>
                </TableContainer>
            )}

            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>
                    Feedback Files
                </DialogTitle>
                <DialogContent>







                    {!isLoadingRawImage && !rawImage && currentImage && (
                        <Typography
                            variant="body1"
                            align="center"
                            style={{ marginTop: 20, color: "red" }}
                        >
                            Unable to view the image
                        </Typography>
                    )}



                    {/* Thumbnails */}
                    <Grid container spacing={2} style={{ marginTop: 20 }}>
                        {selectedFiles.map((file: any) => {

                            const isImage = isImageFile(file.filename);

                            return (
                                <Grid item key={file.file_id}>

                                    {isImage ? (
                                        <ImageThumbnail
                                            file={file}
                                            onClick={() => {
                                                const index = selectedFiles.findIndex((f) => f.file_id === file.file_id);

                                                setCurrentImageIndex(index);
                                                setCurrentImage({
                                                    file: file.download_url,
                                                    name: file.filename
                                                });

                                                setPreviewOpen(true); // open image preview dialog
                                            }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                width: 120,
                                                height: 120,
                                                border: "1px solid #ccc",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 5
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                style={{ display: "block", maxWidth: 120, wordBreak: "break-word" }}
                                            >
                                                {file.filename}
                                            </Typography>

                                            <Button
                                                size="small"
                                                color="primary"
                                                onClick={() => window.open(file.download_url)}
                                            >
                                                Download
                                            </Button>
                                        </div>
                                    )}



                                </Grid>
                            );
                        })}
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => setOpen(false)} color="primary">close</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={previewOpen}
                onClose={() => setPreviewOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogContent>

                    {isLoadingRawImage && <LinearProgress />}

                    {currentImage && isImageFile(currentImage.name) && rawImage && (

                        <img
                            src={rawImage}
                            alt={currentImage?.name}
                            style={{
                                maxWidth: "100%",
                                maxHeight: "600px",
                                display: "block",
                                margin: "0 auto"
                            }}  
                        />

                    )}

                    
                </DialogContent>
                <DialogActions>
                    <Button  onClick={() => setPreviewOpen(false)} color="primary">close</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}


